import { giphyCharcoal } from '@giphy/colors'
import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { DropdownButton } from 'ui'
import { heightFromControlSize } from 'utils'
import FontComponent from './font'

export const Row = styled.div`
    display: flex;
    gap: 10px;
    width: 100%;
`

export const Font = styled(FontComponent)`
    width: 100%;
`

export const SquareButton = styled(DropdownButton)`
    flex-shrink: 0;

    svg,
    i {
        display: block;
        margin: 0 auto;
        width: 100%;
    }
`

export const ColorButton = styled(SquareButton)<{ $isDark: boolean; $size?: ControlSize }>`
    ${({ $isDark, $size }) => {
        const height = heightFromControlSize($size || 'small')

        return css`
            svg {
                height: ${height}px;
                margin: 0 auto;
                width: ${height}px;

                ${$isDark &&
                css`
                    path {
                        stroke: ${giphyCharcoal};
                        stroke-width: 1;
                    }
                `}
            }
        `
    }}
`

export const StrokeOptions = styled.div`
    margin-bottom: 30px;
`

export const TooltipContent = styled.div`
    padding: 30px;
`
